module.exports = __webpack_public_path__ + "static/media/whiteEnvelope.9f3a6bdd.svg";